<template>
    <div class="pushList">
		<leftnav class="fl" mkcode="C" :itemcode="yj_itemcode"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
                <div class="whitebox right_topbox">
					<div class="right_boxtitle map_title_tab">
						<span class="title" :class="{'current':navValue == list.value}" @click="navValue = list.value;ajaxsearchcompany(1)" v-for="(list) in navList" :key="list.value">{{list.label}}</span>
					</div>
                    <!-- 省市区筛选 -->
                    <cityScreen @getEnterpriseList="cityScreenFun" :isShowCounty="false"></cityScreen> 
                    <dl class="opport-screen bdbe">
                        <dt class="fl">推送单位</dt>
                        <dd class="fl "> 
                            <span @click="pushCcompanyId = '';ajaxsearchcompany();" :class="pushCcompanyId == '' ?'a-screen current' : 'a-screen'"  >全部 </span>
                            <span :key="index" v-for="(item,index) in companylist" @click="pushCcompanyId = item.id;ajaxsearchcompany();"
                                :class="pushCcompanyId == item.id ?'a-screen current' : 'a-screen'"
                                >{{item.title}} </span>
                                    
                        </dd>
                    </dl>
				</div>
				<div class="whitebox">
					<div class="py-3">
                        <div v-if="userdata.zsdn_version == 1">
                            <table border="0" cellspacing="0" cellpadding="0" class="land_table" v-if="userdata.zsdn_version == 1">
							<tr>
								<th>序号</th>
                                <th>项目位置</th>
                                <!-- <th>项目城市</th> -->
								<th>项目名称</th>
                                <th>投资主体</th>
                                <th style="width: 100px;">所在城市</th>
								<th>总面积（亩）</th>
                                <th>{{ navValue == 1 ? '拟' : '已' }}推送单位</th>
                                
                                <th style="width: 100px;">{{ navValue == 1 ? '操作' : '推送状态' }}</th>
							</tr>
                            <tr v-for="(item,index) in enterpristlist" :key="item.stockcode">
                                <td>{{(page-1)*pageSize+index+1}}</td>
                                <td>{{item.area}}</td>
                                <!-- <td>{{item.city}}</td> -->
                                <td class="title" @click="handlerLinkLocal('/landDetail?id='+item.id+'&pageType=3')">{{item.projectName}}</td>
                                <td>{{item.sourceEnterprise}}</td>
                                <td >{{item.sourceArea || '-'}}</td>
                                <td>{{item.size.toFixed(2)}}</td>
                                <td >{{item.matchCompanyName || '-'}}</td>
                                
                                <td class="collectfont1" v-if="navValue == 1">
                                    <span @click="handlerLinkLocal('/pushDetail?id='+item.id)">开始推送 > </span>
                                </td>
                                <td v-if="navValue == 2" style="width: 70px;">
                                    <span>已推送 </span>
                                </td>
                            </tr>
                        </table>
                        </div>
                        
                        <div v-if="userdata.zsdn_version == 2">
                            <table border="0" cellspacing="0" cellpadding="0" class="land_table" >
                                    <tr>
                                        <th>序号</th>
                                        <th>公司名称</th>
                                        <th>项目名称</th>
                                        <th>投资来源地</th>
                                        <th>行业</th>
                                        <th>投资地点</th>
                                        <th>投资金额（万）</th>
                                        <th style="width: 100px;">日期</th>
                                        <th style="width: 70px;">{{ navValue == 1 ? '操作' : '推送状态' }}</th>
                                    </tr>
                                    <tr v-for="(item,index) in enterpristlist" :key="item.stockcode">
                                        <td>{{(page-1)*pageSize+index+1}}</td>
                                        <td>{{item.investArea}}</td>
                                        <td class="title" @click="handlerLinkLocal('/investDetail?id='+item.id+'&pageType=3')">{{item.title}}</td>
                                        <td>{{item.sourceArea}}</td>
                                        <td>{{item.industry}}</td>
                                        <td>{{item.investArea}}</td>
                                        <td>{{item.money}}</td>
                                        <td style="width: 100px;">{{item.time}}</td>
                                        <td class="collectfont1" v-if="navValue == 1" >
                                            <span @click="handlerLinkLocal('/pushDetail?id='+item.id)">开始推送 > </span>
                                        </td>
                                        <td v-if="navValue == 2">
                                            <span>已推送 </span>
                                        </td>
                                    </tr>
                            </table>
                        </div>
                        
                        <el-dialog class="pushDialog" :modal-append-to-body="false" append-to-body title="" :visible.sync="isShowPush" width="850px" top="15vh">
                            <div><el-button type="primary" size="small" class="fr mr-3 mb-3">确认推送</el-button></div>
                            <table border="0" cellspacing="0" cellpadding="0" class="land_table"> 
                                <tr>
                                    <th rowspan="4" width="120px">接收单位</th>
                                    <!-- <td colspan="3">{{pushData.company}}</td> -->
                                     <td>单位名称</td>
                                    <td colspan="3">{{pushData.company}}<el-button size="small" type="success " class="fr mr-1">修改</el-button></td>
                                </tr>
                                <tr>
                                    <td>业务范围</td>
                                    <td colspan="3">{{pushData.scope}}</td>
                                </tr>
                                <tr>
                                    <td>所在省份</td>
                                    <td>{{pushData.province}}</td>
                                    <td>所在城市</td>
                                    <td>{{pushData.city}}</td>
                                </tr>
                            </table>
                             <table border="0" cellspacing="0" cellpadding="0" class="land_table mt-3"> 
                                <tr>
                                    <th rowspan="6" width="120px">项目基本信息</th>
                                     <td>项目名称</td>
                                    <td colspan="3">{{pushData.projectname}}</td>
                                </tr>
                                <tr>
                                    <td>行业分类</td>
                                    <td colspan="3">{{pushData.smallIndustry}}</td>
                                </tr>
                                <tr>
                                    <td>所在省份</td>
                                    <td>{{pushData.province}}</td>
                                    <td>所在城市</td>
                                    <td>{{pushData.city}}</td>
                                </tr>
                                <tr>
                                    <td>土地使用权人</td>
                                    <td>{{pushData.investor}}</td>
                                    <td>投资主体</td>
                                    <td>{{pushData.company}}</td>
                                </tr>
                                <tr>
                                    <td>面积（亩）</td>
                                    <td>{{pushData.totalarea}}</td>
                                    <td>容积率</td>
                                    <td>{{pushData.capacity}}</td>
                                </tr>
                                <tr>
                                    <td>土地用途</td>
                                    <td>{{pushData.landuse}}</td>
                                    <td>土地使用年限</td>
                                    <td>{{pushData.uselife}}</td>
                                </tr>
                            </table>
                        </el-dialog>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script> 
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'clueManagement',
    computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
    data() {
        return {
            userdata: {},
            page: 1,
            haspage: true,
            pageSize: 20,
            total: 0,
            totalPage: 1,
            maxPage: 10,
            yj_itemcode: "A01",
            enterpristlist: [{
                id: 1,
                size: 0,
                col:1,
                stockcode: '1',
                region: '河北省秦皇岛市',
                projectname: '秦皇岛海港区盛步储能技术有限公司',
                totalarea: '44.72', 
                landuse: '仓储用地', 
                company: '中国二十二冶集团有限公司深圳分公司', 
                investor: '晶科电力有限公司', 
                source: '浙江省嘉兴市', 
                signDate: '2025-11-25',
                province: '河北省',
                city: '秦皇岛市',
                scope: '该公司在集团内实际业务分工范围的描述',
                capacity: '0.8',
                uselife: '50年',
                }],
            isShowPush: false,
            pushData: {},
            navList: [
                {value:1,label:'待推送项目'},
                {value:2,label:'已推送项目'},
            ],
            navValue: 1,
            cityid: '',
            provinceid: '',
            countyid: '',
            pushCcompanyId: '',
            companylist: [],
        };
    },
    mounted() { 
        this.userdata = this.getuseriformation();
        this.getPushCompanyList();
        this.ajaxsearchcompany();
    },
    methods: {
        //获取推送公司列表
        getPushCompanyList() { 
            this.bus.$emit('loading', true);
            this.$axios.get(this.$api.metall.Company.list()).then((res) => {
               if (res.data.success) { 
                console.log('公司列表',res);
                this.companylist = res.data.list;
                this.bus.$emit('loading', false);
               }
            })
        },
        //省份城市选择 
        cityScreenFun(pid,cid,cuid){ 
            this.cityid = cid;
            this.countyid = cuid; 
            this.provinceid = pid;
            this.ajaxsearchcompany();
        },
        pushFun(item) {
            console.log('推送', item);
            this.pushData = item;
            this.isShowPush = true;
        },
        ajaxsearchcompany(pages) {
            this.page = pages ? pages : 1;
            var ajaxurl = '';
            if(this.navValue == 1){
               if(this.userdata.zsdn_version == 1){
                ajaxurl = this.$api.metall.LandPush.Unpublished();  
                }else{
                    ajaxurl = this.$api.metall.InvestPush.Unpublished();
                }
            }else{
                if(this.userdata.zsdn_version == 1){
                ajaxurl = this.$api.metall.LandPush.Published();
                }else{
                    ajaxurl = this.$api.metall.InvestPush.Published();
                }
            }
            this.bus.$emit('loading', true);
            let params = {
                page: this.page,
                pageSize: this.pageSize,
                city:this.cityid,
                province:this.provinceid,
                county:this.countyid,
                 pushCompanyId: this.pushCcompanyId,
            };
           this.$axios.get(ajaxurl, { params: params }).then((res) => {
               if (res.data.success) { 
                console.log('推送列表',res);
                this.enterpristlist = res.data.list;
                this.totalPage = res.data.totalPage;
                this.total = res.data.totalRecord;
                this.pageSize = res.data.pageSize;
                this.bus.$emit('loading', false);
               } else {
                //    this.$message.error(res.data.message);
                    this.bus.$emit('loading', false);
               }
           })
        },
        delClue(item) {
            console.log('移除线索管理', item);
        },
        pageHandler(page) {
            this.page = page;
            this.ajaxsearchcompany(page);
        },
    },
};
</script>
<style lang="scss">
.pushDialog {
.land_table tr td{
    border-bottom: 1px solid #dcdcdc;
    min-width: 136px;
    font-size: 16px;
    padding: 10px 0;
}
}
</style>